<template>
  <div
    :class="`shine ${disabled ? 'disabled' : ''} ${className}`"
    :style="{ animationDuration }"
    :data-text="text"
  >
    {{text}}
  </div>
</template>

<script>
export default {
  name: "ShinyButton",
  props: {
    text: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    speed: {
      type: Number,
      default: 1,
    },
    className: {
      type: String,
      default: "",
    },
  },
  computed: {
    animationDuration() {
      return `${this.speed}s`;
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/assets/styles/quasar.variables.scss" as *;
$duration: 2s;

.shine {
  position: relative;
  display: inline-block;
  color: $primary-light;
  overflow: hidden;

  &::after {
  content: attr(data-text); /* дублируем текст */
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  color: $primary-light;
  background: linear-gradient(
    120deg,
    transparent 40%,
    rgba(255, 255, 255, 0.8) 50%,
    transparent 60%
  );
  background-size: 200% 100%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shine 1s linear infinite;
}
}

.shine.disabled {
  animation: none;
}

@keyframes shine {
	0% {
    background-position: 100%;
	}
	100% {
    background-position: -100%;
	}
}
</style>
